import React from "react";

const FilterIcon = () => {
  return (
    <svg
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.999999 3.66667L4.75 3.66667M13.5 3.66667L21 3.66667M13.5 3.66667C13.5 2.19387 12.3807 0.999999 11 0.999999C9.61925 0.999999 8.5 2.19387 8.5 3.66667C8.5 5.13947 9.61925 6.33333 11 6.33333C12.3807 6.33333 13.5 5.13947 13.5 3.66667ZM8.5 13L16 13M16 13C16 14.4728 17.1193 15.6667 18.5 15.6667C19.8808 15.6667 21 14.4728 21 13C21 11.5272 19.8807 10.3333 18.5 10.3333C17.1192 10.3333 16 11.5272 16 13ZM0.999999 13L4.75 13M9.75 22.3333L21 22.3333M3.5 19.6667C4.88071 19.6667 6 20.8606 6 22.3333C6 23.8061 4.88071 25 3.5 25C2.11929 25 1 23.8061 1 22.3333C1 20.8606 2.11929 19.6667 3.5 19.6667Z"
        stroke="#3F3F3F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FilterIcon;
